const dogCareDetailedRateCard = {
  key: "dog-care",
  title: "Dog Care Detailed Rate Card",
  note:
    "Indicative pet support pricing. Final price depends on pet size, temperament, time slot, and recurring schedule.",
  sections: [
    {
      title: "Walking",
      items: [
        { name: "Dog walk - 30 mins", price: "₹199 per walk" },
        { name: "Dog walk - 60 mins", price: "₹349 per walk" },
      ],
    },
    {
      title: "Sitting",
      items: [
        { name: "Dog sitting visit", price: "₹399 onwards per visit" },
        { name: "Recurring pet support plan", price: "₹1999 onwards monthly" },
      ],
    },
    {
      title: "Consultation",
      items: [
        { name: "Pet care consultation", price: "₹199" },
      ],
    },
  ],
};

export default dogCareDetailedRateCard;